'use strict';

/*global services*/

function Jeditable() {

}

Jeditable.prototype = $.extend({}, {
  constructor: 'Jeditable',

  //----------------------------------------------------------------------------

  changeInput: function changeInput($input) {
    var _this = this;

    var name = $input.data('jeditable_name');
    var value = $input.val();

    name = name.split(':');

    var className = name[0];
    name = name[1].split('[');

    var field = name[0];
    var key = name[1].replace('[', '').replace(']', '');

    _this.saveValue($input, className, field, key, value);

    return _this;
  },

  saveValue: function ($input, className, field, key, value) {
    var _this = this;

    $.post(services.get('router').path('jeditable'), { class: className, field: field, key: key, value: value }, function (res) {
      $input.parent().removeClass('has-error');

      if (res.msg === 'SUCCESS') {
        services.get('notifications').viewSaveMessage();

        if ($input.data('callback')) {
          var callback = $input.data('callback');
          if (callback in window) {
            window[callback]($input);
          }
        }
      } else {
        $input.parent().addClass('has-error');
      }
    });

    return _this;
  }

});

(function ($) {
  var jeditable = new Jeditable();

  var methods = {
    init: function (/*options*/) {
      // options are not used
      //var opts = $.extend({}, $.fn.k2_jeditable.defaults, options);

      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('jeditable-init')) {
          return;
        }

        $this.addClass('jeditable-init');

        $this.on('change', function () {
          jeditable.changeInput($(this));
        });
      });
    }
  };

  $.fn.k2_jeditable = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_jeditable');
    }

  };

  $.fn.k2_jeditable.defaults = {};

})(jQuery);
